import { render, staticRenderFns } from "./DisableUser.vue?vue&type=template&id=724891ea"
import script from "./DisableUser.vue?vue&type=script&lang=ts"
export * from "./DisableUser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports